import { VFC } from 'react'
import { ModalProps } from 'src/components/hoc/asModal'

import { asModal } from 'src/components/hoc/asModal'
import { Button, ButtonsDiv, Layout } from './styles'

const SalesDemoModalContent: VFC<ModalProps<{}>> = ({ close }) => (
  <Layout>
    <h3>デモアカウントではこの機能を使うことができません</h3>
    <ButtonsDiv>
      <Button onClick={() => close()}>OK</Button>
    </ButtonsDiv>
  </Layout>
)

export const SalesDemoModal = asModal(SalesDemoModalContent)
